<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";
import { getToken } from "@/utils/auth";
export default {
  created() {
    if (!getToken()) {
      this.$router.replace("/auth-login");
    } else {
      axios({
        baseURL: process.env.VUE_APP_KW_AUTH_BASE_URL,
        url: "/applyConfig/checkApply?systemCode=cgxComClient",
        method: "get"
      }).then((res) => {
        const response = res.data;
        // 请求失败跳转页面
        if (res.status !== 200 || res.data.code !== 200) {
          this.$nextTick(() => {
            this.$router.replace("/stop");
          });
          return;
        }
        // 请求成功  是否开放使用
        if (response.data.applyFlag === "false" || response.data.applyFlag === false) {
          this.$nextTick(() => {
            this.$router.replace("/stop");
          });
          return;
        }
      });
    }
  }
};
</script>

<style lang="less">
// 自定义弹窗样式
.el-message-box {
  border: none;
  border-radius: 10px;

  .el-message-box__header {
    background-color: #bd1a2d !important;
    font-weight: bold;
    .el-message-box__title {
      color: white;
    }
  }

  .el-message-box__btns {
    .el-button--primary {
      background-color: #bd1a2d !important;
      border: none;
    }
  }
}

body {
  margin: 0 !important;
  padding: 0 !important;
  background-color: #f2f2f2;
}

.img_18 {
  width: 18px;
  height: 18px;
}

.img_16 {
  width: 16px;
  height: 16px;
}

.img_10 {
  width: 10px;
  height: 10px;
  margin-left: 10px;
}

.img_14 {
  width: 14px;
  height: 14px;
}

.img_8 {
  width: 6px;
  height: 11px;
}
.rightBox {
  height: calc(100vh - 7.8vw - 80px);

  .title-box {
    display: flex;
    align-items: center;
    margin: 5px 0 5px 10px;

    .text {
      font-family: Microsoft YaHei;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      margin-left: 8px;
    }
  }
  /* 隐藏滚动条，启用滚动 */
  .card {
    overflow: scroll; /* 或者 overflow: auto */
  }

  /* 针对 WebKit 浏览器隐藏滚动条 */
  .card::-webkit-scrollbar {
    display: none;
  }
  .card {
    margin-top: 14px;
    height: calc(100vh - 7.8vw - 43px);
    overflow-y: auto;
    background: #ffffff;
    box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    padding: 0 30px !important;
    box-sizing: border-box;
    // 标题
    .title_text {
      display: flex;
      align-items: center;
      padding-top: 30px;
      box-sizing: border-box;
      .red {
        height: 16px;
        border: 2px solid #bd1a2d;
      }

      .name {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 18px;
        color: #000000;
        margin-left: 7px;
      }
    }
  }
}
.el-submenu__title {
  padding-left: 0;
  padding: 0 !important;
}

/* 针对整个滚动条的样式 */
::-webkit-scrollbar {
  width: 6px; /* 滚动条的宽度 */
  height: 6px; /* 垂直滚动条的高度（如果需要垂直滚动条的话） */
}

/* 滚动条轨道的样式 */
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2); /* 轨道的背景色 */
  border-radius: 10px; /* 圆角 */
}

/* 滚动条滑块的样式 */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.4); /* 滑块的颜色 */
  border-radius: 10px; /* 圆角 */
}

/* 当用户悬停在滑块上时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* 悬停时的颜色 */
}
.add_btn,
.button,
.submitButt {
  cursor: pointer;
}
.back_btn {
  display: inline-block;
  padding: 6px 26px;
  box-sizing: border-box;
  background: #bd1a2d;
  border-radius: 4px;
  border: 1px solid #e58a94;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  margin: 30px 0;
  cursor: pointer;
}
</style>
